// extracted by mini-css-extract-plugin
export default {"big-button":"work-as_big-button__9tACH","later":"work-as_later__2d+jY"};